'use client';

import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AdminBusinessUnitSetupButton } from './AdminBusinessUnitSetupButton';

type Props = {
  /** Business unit / project name shown before "— Dashboard". If omitted, only "Dashboard" is shown. */
  unitName?: string | null;
};

/**
 * One title row: project name and "— Dashboard" on the left, admin gear on the right.
 * Use for all dashboard home pages; place filters/date controls in a row below, not in the right slot.
 */
export function DashboardTitleBar({ unitName }: Props) {
  const name = unitName?.trim() || null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 2,
        mb: 2,
        minHeight: 40,
        flexWrap: 'nowrap',
      }}
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 600,
          flex: 1,
          minWidth: 0,
        }}
      >
        {name ? (
          <>
            <Box component="span" color="text.primary">
              {name}
            </Box>
            <Box
              component="span"
              color="text.secondary"
              fontWeight={500}
              sx={{ pl: 0.75 }}
            >
              — Dashboard
            </Box>
          </>
        ) : (
          <Box component="span" color="text.primary">
            Dashboard
          </Box>
        )}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <AdminBusinessUnitSetupButton />
      </Box>
    </Box>
  );
}
